import get from 'lodash/get';

import {
  FIELD_PATHS,
  FIELD_VALUES,
  LIABILITIES_CLEARING_FROM_OTHER_SOURCE,
  LIABILITIES_WITH_NEW_LIMIT,
  LIABILITY_FIELDS_STATES,
  LOAN_OPTION,
} from '@funnels/constants';

import { useDidUpdate } from '../useDidUpdate';
import { useFormValues } from '../useFormValues';

/**
 * this hook is used for updating the New limit for revolving and not-revolving
 * when credit limit, loan option changes
 * @param index liability Index
 */
export function useUpdateNewLimit(index: number) {
  const [formValues, setFormValues] = useFormValues();
  const liability = get(formValues, FIELD_PATHS.LIABILITY(index), {});
  const type = get({ liabilities: [liability] }, FIELD_PATHS.LIABILITY_TYPE(0));
  const creditLimit = get({ liabilities: [liability] }, FIELD_PATHS.LIABILITY_CREDIT_LIMIT(0));
  const currentBalance = get(formValues, FIELD_PATHS.LIABILITY_OUTSTANDING_BALANCE(index));
  const clearingFromThisLoan = get({ liabilities: [liability] }, FIELD_PATHS.LIABILITY_CLEARING_FROM_THIS_LOAN(0));
  const clearingFromOtherSource = get(
    { liabilities: [liability] },
    FIELD_PATHS.LIABILITY_CLEARING_FROM_OTHER_SOURCE(0)
  );

  const isRevolving = LIABILITIES_WITH_NEW_LIMIT.includes(type);
  const isCreditLimitDisabled = LIABILITY_FIELDS_STATES.CREDIT_LIMIT.DISABLED.includes(type);

  let selectedOption: LOAN_OPTION | undefined;

  if (clearingFromThisLoan === true) {
    selectedOption = LOAN_OPTION.CONSOLIDATE;
  } else if (clearingFromOtherSource === LIABILITIES_CLEARING_FROM_OTHER_SOURCE.PAYING_OUT) {
    selectedOption = LOAN_OPTION.CLEAR_FROM_OTHER_SOURCE;
  } else if (clearingFromThisLoan === false && !clearingFromOtherSource) {
    selectedOption = LOAN_OPTION.NONE;
  }

  useDidUpdate(() => {
    if (type === FIELD_VALUES.HOME_LOAN) {
      if (selectedOption === LOAN_OPTION.CONSOLIDATE) {
        setFormValues(FIELD_PATHS.LIABILITY_NEW_LIMIT(index), 0);
      }

      if (selectedOption === LOAN_OPTION.NONE) {
        setFormValues(
          FIELD_PATHS.LIABILITY_NEW_LIMIT(index),
          get(formValues, FIELD_PATHS.LIABILITY_CREDIT_LIMIT(index))
        );
      }
    }
  }, [type]);

  useDidUpdate(() => {
    if (index === -1) {
      return;
    }

    switch (selectedOption) {
      case LOAN_OPTION.CONSOLIDATE:
        setFormValues(FIELD_PATHS.LIABILITY_NEW_LIMIT(index), 0);

        break;
      case LOAN_OPTION.CLEAR_FROM_OTHER_SOURCE:
        setFormValues(FIELD_PATHS.LIABILITY_NEW_LIMIT(index), 0);

        break;

      case LOAN_OPTION.NONE:
      default:
        let newCredit = get(formValues, FIELD_PATHS.LIABILITY_CREDIT_LIMIT(index));

        if (isCreditLimitDisabled) {
          newCredit = get(formValues, FIELD_PATHS.LIABILITY_OUTSTANDING_BALANCE(index));
        }
        setFormValues(FIELD_PATHS.LIABILITY_NEW_LIMIT(index), newCredit);
    }

    if (isRevolving) {
      setFormValues(FIELD_PATHS.LIABILITY_NEW_LIMIT(index), get(formValues, FIELD_PATHS.LIABILITY_CREDIT_LIMIT(index)));
    }
  }, [selectedOption, creditLimit]);

  useDidUpdate(() => {
    if (isCreditLimitDisabled && (!selectedOption || selectedOption === LOAN_OPTION.NONE)) {
      setFormValues(FIELD_PATHS.LIABILITY_NEW_LIMIT(index), currentBalance);
    }
  }, [isCreditLimitDisabled, currentBalance]);
}
